import { Grid, TextField, Typography, Autocomplete } from "@mui/material";
import ModalLayout from "components/ModalLayout";
import MDButton from "components/MDButton";
import CancelButton from "components/CancelButton";

const StatusModal = ({
  statusModalOpen,
  statusForm,
  orderStatuses,
  handleStatusChange,
  handleSaveStatus,
  setStatusModalOpen
}) => {
  const selectedStatus = orderStatuses.find(s => s.id === statusForm.status_id) || null;

  return (
    <ModalLayout
      open={statusModalOpen}
      onClose={() => setStatusModalOpen(false)}
      title="Change Order Status"
      subtitle="Order Status"
      maxWidth={640}
      headerContent={
        <Typography variant="body2" color="text.secondary" mt={1}>
          Update the order status and leave additional notes for the team.
        </Typography>
      }
      actions={
        <>
          <CancelButton onClick={() => setStatusModalOpen(false)} />
          <MDButton
            variant="gradient"
            color="info"
            onClick={handleSaveStatus}
            disabled={!statusForm.status_id}
            sx={{ minWidth: 140 }}
          >
            Save
          </MDButton>
        </>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            options={orderStatuses}
            getOptionLabel={(option) => option.name || ""}
            value={selectedStatus}
            onChange={(event, newValue) => {
              handleStatusChange({
                target: {
                  name: "status_id",
                  value: newValue ? newValue.id : ""
                }
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Status"
                variant="outlined"
                fullWidth
                color="success"
                InputProps={{
                  ...params.InputProps,
                  sx: { borderRadius: 2 }
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="description"
            label="Description"
            multiline
            minRows={3}
            value={statusForm.description}
            onChange={handleStatusChange}
            fullWidth
            InputProps={{ sx: { borderRadius: 2 } }}
          />
        </Grid>
      </Grid>
    </ModalLayout>
  );
};

export default StatusModal;
